import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { session } = useAuth();

  useEffect(() => {
    if (session) {
      navigate("/");
    }
  }, [session, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-serif font-bold text-sage-800 mb-4">
            Welcome to Husband & Wife Devotional
          </h1>
          <p className="text-sage-600">
            Sign in or create an account to access all devotionals and save your personal notes.
          </p>
          <p className="text-sage-600 mt-2">
            Not ready to create an account? You can still{" "}
            <a href="/" className="text-sage-800 underline">
              read today's devotional
            </a>{" "}
            or{" "}
            <a href="/archive" className="text-sage-800 underline">
              browse recent devotionals
            </a>.
          </p>
        </div>
        
        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#4d5c4d',
                  brandAccent: '#637663',
                  brandButtonText: 'white',
                },
              },
            },
            className: {
              container: 'auth-container',
              button: 'auth-button',
              anchor: 'auth-link',
            },
          }}
          providers={[]}
          view="sign_up"
          redirectTo={`${window.location.origin}/reset-password`}
        />
      </div>
    </div>
  );
};

export default Login;